import { render, staticRenderFns } from "./baseConfirm.vue?vue&type=template&id=b128ecd2&"
import script from "./baseConfirm.vue?vue&type=script&lang=js&"
export * from "./baseConfirm.vue?vue&type=script&lang=js&"
import style0 from "./baseConfirm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports